"use client";

import type { SDK, SDKConfig } from "@frontend/roz-sdk-core";
import type { MockSdk } from "@frontend/roz-sdk-core/testing";
import { createContext } from "react";

export type SdkInstance = SDK | MockSdk;

export interface SdkContextValue {
  sdk: SdkInstance;
  config: SDKConfig;
  ready: boolean;
}

export const SdkContext = createContext<SdkContextValue | null>(null);
